module.exports = __webpack_public_path__ + "img/MasterSlaveSPI.03b8bbba.png";